import { Pipe, PipeTransform } from '@angular/core';
import { ARBleOrder, ARBleOrderItem } from '../models/agrorendement-ble.model';
import { User } from '../models/user.model';

@Pipe({
  name: 'listUsersForOrder',
  standalone: true,
})
export class ListUsersForOrderPipe implements PipeTransform {
  transform(order: ARBleOrder, attr: any): string {
    const users = new Map<number, string>();
    order.orderItems.forEach((orderItem: ARBleOrderItem) => {
      const user = orderItem.parcel.farm.user;
      const val = user.firstName + ' ' + user.lastName;
      users.set(user.id, val);
    });
    return Array.from(users.values()).sort().join(', ');
  }
}

@Pipe({
  name: 'listFarmsForOrder',
  standalone: true,
})
export class ListFarmsForOrderPipe implements PipeTransform {
  transform(order: ARBleOrder, attr: any): string {
    const farms = new Map<number, string>();
    order.orderItems.forEach((orderItem: ARBleOrderItem) => {
      const farm = orderItem.parcel.farm;
      const val = farm.name;
      farms.set(farm.id, val);
    });
    return Array.from(farms.values()).sort().join(', ');
  }
}
